const experienceCards = {
  props: {
    dynamicClass: ".c-experience-cards.dynamicLoading",
    cardSelector: "experience-cards__card",
    titleSelector: "experience-cards__card-title",
  },

  init: function (baseDom) {
    if (bcl.editMode) {
      return;
    }

    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-experienceCards.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document,
      elements = baseFind.getElementsByClassName(this.props.cardSelector);

    bcl.u.forEach(elements, this.initItem.bind(this));
  },

  initItem: function ($card) {
    const cta = $card.querySelector("a");
    const title = $card.querySelector("." + this.props.titleSelector);
    cta.addEventListener("click", () => {
      // eslint-disable-next-line no-undef
      window.utag.link({
        // eslint-disable-next-line camelcase
        ga4_event_name_eh: "experience card click",
        // eslint-disable-next-line camelcase
        event_action: "Royal Level Experience Card",
        // eslint-disable-next-line camelcase
        event_label: title?.textContent,
        // eslint-disable-next-line camelcase
        event_category: "interaccion",
      });
    });
  },
};

export default experienceCards;
